import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import RetailProcessFlow from "./RetailProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  RETAIL_DOMAIN_INTRO,
  RETAIL_GROUPS,
  RETAIL_USE_CASES_SEO,
  RETAIL_DOMAIN_FAQS,
  RETAIL_ITEM_LIST_JSONLD,
  RETAIL_BREADCRUMB_JSONLD,
  RETAIL_WEBPAGE_JSONLD,
  RETAIL_FAQ_JSONLD,
} from "../../data/retailUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RetailProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = RETAIL_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;

  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function RetailDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");

  const visibleGroups =
    activeFilter === "all"
      ? RETAIL_GROUPS
      : RETAIL_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={RETAIL_DOMAIN_INTRO}
        domainSlug="retail-domain"
        useCaseCount={RETAIL_USE_CASES_SEO.length}
        groupCount={RETAIL_GROUPS.length}
        itemListJsonLd={RETAIL_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={RETAIL_BREADCRUMB_JSONLD}
        faqJsonLd={RETAIL_FAQ_JSONLD}
        webPageJsonLd={RETAIL_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>

      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{RETAIL_DOMAIN_INTRO.title}</h1>
          {RETAIL_DOMAIN_INTRO.content ? (
            <p>{RETAIL_DOMAIN_INTRO.content}</p>
          ) : null}
        </div>
      </header>

      <UseCaseIndexGrid
        useCases={RETAIL_USE_CASES_SEO}
        groups={RETAIL_GROUPS}
        heading="Retail Use Cases"
        onFilterChange={setActiveFilter}
      />

      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={RETAIL_DOMAIN_INTRO.title}
        domainFaqs={RETAIL_DOMAIN_FAQS}
        useCases={RETAIL_USE_CASES_SEO}
      />
    </div>
  );
}

